import { FC, useState, useEffect } from 'react';
import { MapData_Base } from '~/common/typescript/models/MapData';
import { MapDataAPIs } from '~/common/typescript/apis/MapDataAPIs';
import { Spin } from 'antd';
import MapDataItem from './MapDataItem';
import { useAtomValue } from 'jotai';
import { mapDataListRefreshTrigger } from '../../../stores/mapStore';
import { uploadTaskListRefreshTrigger } from '~/stores/UploadTaskStore';
import styled from 'styled-components';

interface MapDataListProps {
  uploadTaskId: number;
  onLoad?: (mapDatas: MapData_Base[]) => void;
}

const MapDataList: FC<MapDataListProps> = ({ uploadTaskId, onLoad }) => {
  const [mapDatas, setMapDatas] = useState<MapData_Base[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const mapDataRefreshTrigger = useAtomValue(mapDataListRefreshTrigger);
  const taskRefreshTrigger = useAtomValue(uploadTaskListRefreshTrigger);

  useEffect(() => {
    setIsLoading(true);
    MapDataAPIs.remote_mapData_getList({
      upload_task_id: uploadTaskId,
      page: 1,
      pageSize: 100,
    })
      .then((response) => {
        if (response && response.results) {
          setMapDatas(response.results);
          onLoad?.(response.results);
        }
      })
      .catch((error) => {
        console.error('Failed to fetch map data:', error);
        setMapDatas([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [uploadTaskId, mapDataRefreshTrigger, taskRefreshTrigger]);

  if (isLoading && mapDatas.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '12px 0' }}>
        <Spin size="small" tip="Đang tải lớp dữ liệu..." />
      </div>
    );
  }

  return (
    <UI_Wrapper>
      {mapDatas.length === 0 ? (
        <div style={{ fontSize: '11px', color: '#94a3b8', padding: '6px 4px', fontStyle: 'italic', textAlign: 'center' }}>
          Chưa có lớp dữ liệu nào
        </div>
      ) : (
        mapDatas.map((item) => <MapDataItem key={item.id} mapData={item} />)
      )}
    </UI_Wrapper>
  );
};

export default MapDataList;

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px 0;
`;
